// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"7de62408","41":"42f20362","61":"a41dc7fb","153":"f7c63dfb","215":"e7512910","228":"d657191c","368":"f29f47de","430":"1ec879be","512":"7236a09f","620":"54832e1b","644":"1e65a776","653":"85a1c2b9","743":"06530f65","799":"b1e3ca49","882":"06c35dbd"}[chunkId] + ".chunk.js";
};